<div class="row">
	<div class="col-11"></div>
	<div class="col text-end">
		<button mat-mini-fab [mat-dialog-close]="true">
			<mat-icon>close</mat-icon>
		</button>
	</div>
</div>

<div class="row" style="margin-top: 10px;">
	<mat-card>

		<mat-card-content>
			<mat-card-title>
				{{user.PERSON.FIRST_NAME}}
				{{user.PERSON.MIDDLE_INITIAL}}
				{{user.PERSON.LAST_NAME}}
				{{user.PERSON.SUFFIX}}'s
				Profile
			</mat-card-title>

			<div> Username : {{user.USER_ID}}</div>
			<div class="col">
				Account Status:
				<span [ngClass]="{ 
						'theme-font-color': loginDetailStatusName == 'Active', 
						'warn-font-color': !(loginDetailStatusName == 'Active') }">
					{{loginDetailStatusName}}
				</span>
				<button *ngIf="loginDetailStatusName != 'Active'" mat-icon-button color="primary" #tooltip="matTooltip"
					[matTooltip]="user.LOGIN_DETAIL_STATUS[0].DESCRIPTION" matTooltipHideDelay="100000"
					[matTooltipPosition]="positionOptions[3]">
					<i class="fa fa-info"></i>
				</button>
			</div>
		</mat-card-content>
	</mat-card>
</div>
<div class="row">
	<mat-accordion class="example-headers-align">
		<mat-expansion-panel [expanded]="step === 0" (opened)="setStep(0)" hideToggle>
			<mat-expansion-panel-header class="disable_ripple">
				<mat-panel-title>

				</mat-panel-title>
				<mat-panel-description>
					<b class="disable_ripple_font"> Contact Information </b>
					<mat-icon>account_circle</mat-icon>
				</mat-panel-description>
			</mat-expansion-panel-header>

			<table class="table">
				<tbody>
					<tr>
						<th scope="row">Name</th>
						<td>
							{{user.PERSON.FIRST_NAME}}
							{{user.PERSON.MIDDLE_INITIAL}}
							{{user.PERSON.LAST_NAME}}
							{{user.PERSON.SUFFIX}}</td>

					</tr>
					<tr>
						<th scope="row">Work Title</th>
						<td>{{user.WORK_TITLE}}</td>
					</tr>
					<tr>
						<th scope="row">Work Address(es)</th>
						<td>
							<app-view-user-work-addresses [user]="user"></app-view-user-work-addresses>
						</td>
					</tr>
					<tr>
						<th scope="row">Email Address</th>
						<td>{{user.EMAIL_ADDRESS}}</td>
					</tr>
					<tr>
						<th scope="row">Telephone Number(s)</th>
						<td>

							{{user.TELEPHONE_NUMBERS==null || user.TELEPHONE_NUMBERS.length <=0 ? "" :
								(user.TELEPHONE_NUMBERS[0].CONTACT_MECHANISMS.PARTY_CONTACT_MECHANISMS[0].PARTY_CONTACT_MECHANISM_PURPOSES[0].CONTACT_MECHANISM_PURPOSE_TYPES.TYPE=='Work Phone'
								? "W:" : "H:" ) + user.TELEPHONE_NUMBERS[0].PHONE_NUMBER }} </td>
					</tr>
				</tbody>
			</table>
			<mat-action-row>
				<button mat-button color="primary" (click)="nextStep()">Next</button>
			</mat-action-row>
		</mat-expansion-panel>

		<mat-expansion-panel [expanded]="step === 1" (opened)="setStep(1)" hideToggle>
			<mat-expansion-panel-header class="disable_ripple">
				<mat-panel-title>

				</mat-panel-title>
				<mat-panel-description>
					<b class="disable_ripple_font"> Region/Organization </b>
					<mat-icon>place</mat-icon>
				</mat-panel-description>


			</mat-expansion-panel-header>

			<table class="table">
				<tbody>
					<tr>
						<th scope="row">Region</th>
						<td>
							{{user?.REGION?.ID!<=0 ? "---" : user?.REGION?.NAME + " " + user.REGION?.CODE}} </td>
					</tr>
					<tr>
						<th scope="row">Works for</th>
						<td>
							{{user.WORKS_FOR.ID<=0 ? "---" : user.WORKS_FOR.NAME | titlecase}} </td>
					</tr>
					<tr>
						<th scope="row">School District(s)</th>
						<td>
							<span *ngIf="user.SCHOOL_DISTRICTS.length > 0">
								<mat-chip-listbox class="example-chip" cdkDropList cdkDropListOrientation="horizontal">
									<mat-chip-option class="example-box" cdkDrag
										*ngFor="let schoolDistrict of  user.SCHOOL_DISTRICTS">
										{{schoolDistrict.DISTRICTS | titlecase }}
									</mat-chip-option>
								</mat-chip-listbox>
							</span>
						</td>
					</tr>
				</tbody>
			</table>
			<mat-action-row>
				<button mat-button color="warn" (click)="prevStep()">Previous</button>
				<button mat-button color="primary" (click)="nextStep()">Next</button>
			</mat-action-row>
		</mat-expansion-panel>

		<mat-expansion-panel [expanded]="step === 2" (opened)="setStep(2)" hideToggle>
			<mat-expansion-panel-header class="disable_ripple">
				<mat-panel-title>

				</mat-panel-title>
				<mat-panel-description>
					<b class="disable_ripple_font"> System Role(s) </b>
					<mat-icon>perm_identity</mat-icon>
				</mat-panel-description>
			</mat-expansion-panel-header>
			<table class="table">
				<tbody>
					<tr>
						<td>
							<mat-chip-listbox class="example-chip" cdkDropList cdkDropListOrientation="horizontal">
								<mat-chip-option class="example-box" cdkDrag *ngFor="let userRole of  user.USER_ROLES">
									{{userRole.ROLE.NAME }}
								</mat-chip-option>
							</mat-chip-listbox>
						</td>
					</tr>

				</tbody>
			</table>
			<mat-action-row>
				<button mat-button color="warn" (click)="prevStep()">Previous</button>
				<button mat-button color="primary" (click)="nextStep()">End</button>
			</mat-action-row>
		</mat-expansion-panel>
	</mat-accordion>
</div>